import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Phone } from 'lucide-react';
import { Button } from '../components/ui/button';

const AccueilPage = () => {
  const navigate = useNavigate();

  const handleCall = () => {
    window.location.href = 'tel:0650088282';
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#F5EFE6] via-white to-[#F5EFE6]">
      {/* Decorative Elements */}
      <div className="absolute top-20 right-10 w-96 h-96 bg-[#C9A961]/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-10 w-96 h-96 bg-[#8B7355]/10 rounded-full blur-3xl"></div>

      {/* Content */}
      <div className="container mx-auto px-4 py-32 relative z-10">
        <div className="max-w-5xl mx-auto text-center">
          
          {/* Logo */}
          <div className="mb-12 flex justify-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/we4jswbw_IMG_9185.png"
              alt="SolinoPro"
              className="w-80 h-auto object-contain drop-shadow-xl"
            />
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Votre artisan BTP
            <span className="block mt-2 text-[#8B7355]">
              pour tous vos travaux
            </span>
          </h1>

          {/* Subtitle */}
          <p className="text-xl md:text-2xl text-gray-600 mb-12 max-w-3xl mx-auto leading-relaxed">
            Pose de sols • Habillage d'escaliers • Finitions murales • Ajustement de portes
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-16">
            <Button 
              onClick={handleCall}
              size="lg"
              className="bg-[#8B7355] hover:bg-[#6B5744] text-white px-10 py-7 rounded-xl font-semibold text-xl transition-all duration-300 hover:shadow-2xl hover:scale-105 flex items-center space-x-3"
            >
              <Phone className="w-6 h-6" />
              <span>06 50 08 82 82</span>
            </Button>
            <Button 
              onClick={() => navigate('/catalogue')}
              size="lg"
              variant="outline"
              className="border-2 border-[#8B7355] bg-white hover:bg-[#F5EFE6] text-[#8B7355] px-10 py-7 rounded-xl font-semibold text-xl transition-all duration-300 flex items-center space-x-3"
            >
              <span>Voir nos tarifs</span>
            </Button>
          </div>

          {/* Features */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="p-6 bg-white/60 backdrop-blur-sm rounded-2xl shadow-lg">
              <div className="text-4xl font-bold text-[#8B7355] mb-2">10+</div>
              <div className="text-gray-600 font-medium">Ans d'expérience</div>
            </div>
            <div className="p-6 bg-white/60 backdrop-blur-sm rounded-2xl shadow-lg">
              <div className="text-4xl font-bold text-[#8B7355] mb-2">500+</div>
              <div className="text-gray-600 font-medium">Projets réalisés</div>
            </div>
            <div className="p-6 bg-white/60 backdrop-blur-sm rounded-2xl shadow-lg">
              <div className="text-4xl font-bold text-[#8B7355] mb-2">Grosse</div>
              <div className="text-gray-600 font-medium">Satisfaction clients</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccueilPage;
